module.exports = __webpack_public_path__ + "static/media/colheitadeira.46d1ee6d.svg";